import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isHabitnuApp } from "../../../utils/white-label";
import { Spacer } from "../../components/spacer";

interface Props {
    onGenerateOtp: () => void;
    loading: boolean;
    show: boolean;
}

export function CodeExpired({ onGenerateOtp, loading, show }: Props) {
    const { t } = useTranslation();
    return (
        <Modal
            className="warning-modal top-20"
            show={show}
        >
            <Modal.Body>
                <div className="flex-reverse close-btn">
                    <i
                        className="fa fa-2x fa-times pointer color-626262"
                        role="presentation"
                        aria-label="close"
                        onClick={() => {
                            window.location.href = "/";
                        }}
                    />
                </div>
                <div
                    className="modal-data-container text-center"
                >
                    <div className="time-expired">00:00</div>
                    <div className="font-weight-700 font-size-20">
                        {t("login.code_expired_1")}
                    </div>
                    <Spacer height={12} />
                    <div className="f-s-14">{t("login.code_expired_2")}</div>
                    <Spacer height={12} />
                    <div className="f-s-14">{t("login.code_expired_3")}</div>
                    <Spacer height={20} />
                    <Button
                        variant="success"
                        className={`w-100 field-height ${
                            isHabitnuApp() ? "btn-success" : "ada-btn-success"
                        }`}
                        onClick={onGenerateOtp}
                        disabled={loading}
                    >
                        {t("login.code_expired_retry")}
                    </Button>
                    <Spacer />
                </div>
            </Modal.Body>
        </Modal>
    );
}
